import React, { Component } from 'react'

import './AtencionCliente.css'

class AtencionCliente extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}


export default AtencionCliente